import queryResults1 from "./queryResults/queryResults1";
import queryResults2 from "./queryResults/queryResults2";
import queryResults3 from "./queryResults/queryResults3";
import millionRowsQuery from "./queryResults/millionRowsQuery";

const queries = {
    1: queryResults1,
    2: queryResults2,
    3: queryResults3,
    4: millionRowsQuery,
};

export default queries;
